import { JobAlertV2 } from './JobAlertV2';

export class CommonJobAlertV2{

    public jobAlert: JobAlertV2 = new JobAlertV2()

}